/** Read names only. Never return or log cookie values, URLs or project identifiers. */
export function authCookieNames(header: string): string[] {
  return header.split(';').filter((part) => part.includes('='))
    .map((part) => part.slice(0, part.indexOf('=')).trim()).filter(Boolean);
}

/**
 * Bounded observations, not authentication decisions. Cookie headers cannot
 * establish Domain, Path, expiry or whether a present proof is valid.
 */
export function authProofDiagnostics(names: string[], supabaseUrl: string | undefined, cookieDomain: string | undefined) {
  let key: string | undefined;
  try {
    const host = new URL(supabaseUrl ?? '').hostname;
    if (host) key = `sb-${host.split('.')[0]}-auth-token`;
  } catch { /* An invalid setting is reported only as a boolean. */ }
  const matches = (name: string, base: string) => name === base ||
    (name.startsWith(base) && /^\.\d+$/.test(name.slice(base.length)));
  const sessionNames = names.filter((name) => key && matches(name, key));
  const proofNames = names.filter((name) => key && matches(name, `${key}-code-verifier`));
  return {
    projectKeyConfigured: Boolean(key),
    cookieMode: cookieDomain ? 'configured-domain' : 'host-only',
    sessionPresent: sessionNames.length > 0,
    duplicateSessionName: new Set(sessionNames).size < sessionNames.length,
    proofPresent: proofNames.length > 0,
    duplicateProofName: new Set(proofNames).size < proofNames.length,
    otherProjectProofPresent: names.some((name) => /^sb-.+-auth-token-code-verifier(?:\.\d+)?$/.test(name) && !proofNames.includes(name)),
  };
}
